import http from './default'

export default class SyncApplStatusService {
  static async postSync(procNum) {
    return await http.post(
      `${process.env.REACT_APP_SYNC_APPL_STATUS}/v1/appl/${procNum}/fix-status`,
    )
  }
}
